/**
 * Infrastructure Layer - Native Camera Adapter
 * 
 * Implementación del escáner de cámara para plataformas nativas (iOS/Android)
 * usando expo-camera.
 */

import {Camera} from 'expo-camera';
import {
  ICameraScanner,
  CameraPermissionStatus,
  ScanResult,
} from '../../../domain/camera/interfaces/ICameraScanner';

export class NativeCameraAdapter implements ICameraScanner {
  private scanning: boolean = false;

  async requestPermissions(): Promise<CameraPermissionStatus> {
    const {status, canAskAgain} = await Camera.requestCameraPermissionsAsync();
    return {
      granted: status === 'granted',
      canAskAgain,
    };
  }

  async hasPermission(): Promise<boolean> {
    const {status} = await Camera.getCameraPermissionsAsync();
    return status === 'granted';
  }

  async startScanning(
    onScan: (result: ScanResult) => void,
    onError?: (error: Error) => void
  ): Promise<void> {
    try {
      const hasPermission = await this.hasPermission();
      if (!hasPermission) {
        throw new Error('No se tienen permisos de cámara');
      }
      this.scanning = true;
    } catch (error) {
      if (onError) {
        onError(error as Error);
      }
      throw error;
    }
  }

  async stopScanning(): Promise<void> {
    this.scanning = false;
  }

  isScanning(): boolean {
    return this.scanning;
  }
}
